module.exports = __webpack_public_path__ + "static/media/summarize-icon-9.jpg.0c3bf8b4.png";